import React, { useMemo } from 'react';

import { classNames } from '../../utils/css';

const Button = ({
  children,
  variant = 'contained',
  size = 'medium',
  color = 'secondary',
  fullWidth = false,
  className,
  disabled = false,
  href,
  ...restProps
}) => {
  const classes = useMemo(
    () =>
      classNames(
        className,
        'button_root',
        `button__variant_${variant}`,
        `button__size_${size}`,
        `button__color_${color}`,
        {
          'button__fullwidth': fullWidth,
          'button__disabled': disabled,
        },
      ),
    [className, color, disabled, fullWidth, size, variant],
  );

  const isLink = useMemo(() => Boolean(href), [href]);

  const Element = useMemo(
    () => (isLink ? 'a' : 'button'),
    [isLink],
  );

  return (
    <Element
      disabled={disabled}
      className={classes}
      href={href || undefined}
      {...restProps}
    >
      {children}
    </Element>
  );
};

export default Button;
